import { IframeQueryParameters } from '@wix/wix-chatbot-common/browser';

import { UrlQueryParameters } from './types';

export const chatbotSliderAnimationDuration = 150;

class HelpCenterService {
  private readonly _url: URL;

  constructor(url: string) {
    this._url = new URL(url);
  }

  get isFullWidth(): boolean {
    return this._url.searchParams.get(UrlQueryParameters.FullWidth) === 'true';
  }

  get provideRuntimeDataFromSDK(): boolean {
    return (
      this._url.searchParams.get(
        IframeQueryParameters.provideRuntimeDataFromSDK,
      ) === 'true'
    );
  }
}

export const helpCenterService = new HelpCenterService(window.location.href);
